import React from "react";
import "./altara.scss";
import Promodetail from "../../../component/promodetail/promodetail";
import promorumah from "../../../assets/promodetail/promodetail";
import Buttoncta from "../../../component/buttoncta/buttoncta.jsx";
import ScrollToHashElement from "../../home/ScrollToHashElement.js";
import data from "../../../component/promodetail/promodetailc.json";
import Cardrumahdetail from "../../../component/cardrumahdetail/cardrumahdetail.jsx";
import datacard from "../../../component/cardrumahdetail/cardrumahdetail.json";
import altaraHome from "../../../assets/detailrumah/altarahome/altara.js";
const imageMap = {
  altaraHome,
};

const altara = () => {
  return (
    <div className="altara">
      <div className="container-promo">
        <ScrollToHashElement />
        {data.altara.map((promo, index) => {
          // Determine the logo dynamically
          const fotopromo = promorumah[promo.imagehs];
          return (
            <Promodetail
              key={index}
              imagehs={fotopromo} // Dynamically import logo images
              titlepromo={promo.titlepromo}
              subtitle={promo.subtitle}
              details={promo.details}
              whatsappLink={promo.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="judul-produk">OUR HOME</div>
      <div className="container-cardrumah">
        {datacard.altara.map((card, index) => {
          // Determine the logo dynamically
          return (
            <Cardrumahdetail
              key={index}
              carousel={imageMap[card.imagerumah]}
              titlerumah={card.titlerumah}
              subtitlerumah={card.subtitlerumah}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <Buttoncta />
    </div>
  );
};

export default altara;
